import React from "react";
import { HiOutlinePlayCircle } from "react-icons/hi2";


const PreviewButton = ({ redirectToWebPlugin }) => {
  return (
    <button
      onClick={redirectToWebPlugin}
      className="
      text-md inline-flex items-center justify-center gap-1 rounded-md transition-all h-10 ring-gray-100
      pl-4 pr-5 whitespace-nowrap bg-gray-100 border-gray-200 dark:bg-gray-800 border hover:ring-4
      hover:bg-gray-200 text-primary dark:border-gray-700 dark:text-gray-50 dark:ring-gray-700"
    >
      <span className="sr-only">Preview button</span>
      <HiOutlinePlayCircle size={20} />
      Preview
    </button>
  );
};

export default PreviewButton;


/***
 * <button
      title="Preview"
      onClick={redirectToWebPlugin}
      className="
      w-10 h-10 text-gray-500 flex items-center justify-center rounded-md transition-all
      hover:bg-gray-100 dark:hover:bg-gray-800  hover:text-indigo-500 active:scale-90"
    >
      <span className="sr-only">Preview button</span>
      <CgPlayTrackNextO  size={24} />
    </button>
 */